module.exports = {"430921102":"明山头镇","430921103":"青树嘴镇","430921106":"厂窖镇","430921107":"武圣宫镇","430921125":"南洲镇","430921126":"华阁镇","430921127":"茅草街镇","430921128":"三仙湖镇","430921129":"麻河口镇","430921131":"浪拔湖镇","430921201":"乌嘴乡","430921212":"中鱼口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430921.json
// module id = 1886
// module chunks = 0